import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export function PickAnimationPopup({ number, onComplete }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onComplete, 300);
    }, 900);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* Backdrop flash */}
          <motion.div
            className="absolute inset-0 bg-hash-gold/10"
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 0.3, 0] }}
            transition={{ duration: 0.6 }}
          />

          {/* Center popup */}
          <motion.div
            className="relative"
            initial={{ scale: 0.2, opacity: 0, rotate: -10 }}
            animate={{ scale: [0.2, 1.3, 1], opacity: 1, rotate: 0 }}
            exit={{ scale: 0.5, opacity: 0 }}
            transition={{ type: 'spring', damping: 12, stiffness: 200 }}
          >
            {/* Glow ring */}
            <motion.div
              className="absolute inset-0 rounded-full bg-hash-gold/20 blur-xl"
              animate={{ scale: [1, 1.5, 1], opacity: [0.5, 0.2, 0.5] }}
              transition={{ duration: 0.8, repeat: Infinity }}
            />

            {/* Main circle */}
            <div className="relative w-32 h-32 rounded-full bg-gradient-to-br from-hash-gold via-hash-gold-light to-hash-gold-dark flex items-center justify-center border-4 border-white/20 shadow-[0_0_60px_rgba(238,212,91,0.5)]">
              <span className="text-4xl font-bold text-white drop-shadow-lg">
                {number}
              </span>
            </div>

            {/* Sparkles */}
            {[...Array(6)].map((_, i) => (
              <motion.div
                key={i}
                className="absolute w-2 h-2 rounded-full bg-hash-gold-light"
                initial={{ scale: 0, x: 0, y: 0 }}
                animate={{
                  scale: [0, 1, 0],
                  x: Math.cos((i * 60 * Math.PI) / 180) * 80,
                  y: Math.sin((i * 60 * Math.PI) / 180) * 80,
                }}
                transition={{ duration: 0.6, delay: 0.1 }}
                style={{ top: '50%', left: '50%', marginLeft: '-4px', marginTop: '-4px' }}
              />
            ))}
          </motion.div>

          {/* Text below */}
          <motion.p
            className="absolute mt-48 text-hash-gold text-lg font-bold text-shadow-gold"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ delay: 0.2 }}
          >
            Number Picked!
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default PickAnimationPopup;
